import {
  IconContainer,
  StyleContainerPlaceholder,
  StyledContainer,
} from "./session-sent-badge.style";
import { SessionSentBadgeColor } from "./session-sent-badge.types";
import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds/components/icon";

type Props = {
  label: string;
  isVisible?: boolean;
  color?: SessionSentBadgeColor;
};

export const MDSSessionSentBadge = ({ color, isVisible, label }: Props) => {
  if (!isVisible) {
    return <StyleContainerPlaceholder />;
  }

  return (
    <StyledContainer color={color}>
      <IconContainer>
        <MDSIcon kind={MDSIconKind.Check} color={MDSIconColor.Inherit} size={16} />
      </IconContainer>{" "}
      {label}
    </StyledContainer>
  );
};
